export default __webpack_public_path__ + "static/media/Heart of Pashtun.a881d627.jpg";